import { Component, output, ChangeDetectionStrategy, inject } from '@angular/core';
import { DvBadgeDotComponent, DvButtonComponent } from '@devinco/ui/dds';
import { PoiVisibilityService } from '../../services/poi-visibility.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-map-button-group',
  imports: [DvBadgeDotComponent, DvButtonComponent, TranslatePipe],
  templateUrl: './map-button-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map-button-group.component.scss',
})
export class MapButtonGroupComponent {
  showLegendClicked = output<void>();
  focusMyLocationClicked = output<void>();
  changeLanguageClicked = output<void>();
  mapViewToggled = output<boolean>();

  isAerialMapOn: boolean = false;
  hasHiddenPoiTypes = inject(PoiVisibilityService).hasHiddenTypes;

  focusMyLocation(): void {
    this.focusMyLocationClicked.emit();
  }

  showLegend(): void {
    this.showLegendClicked.emit();
  }

  changeLanguage(): void {
    this.changeLanguageClicked.emit();
  }

  navigateToInfo(): void {
    window.location.assign('/info');
  }

  toggleMapView(): void {
    this.isAerialMapOn = !this.isAerialMapOn;
    this.mapViewToggled.emit(this.isAerialMapOn);
  }
}
